import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Link,
  UnorderedList,
  OrderedList,
  ListItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import type { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import PageMeta from './PageMeta';

export function LegalLayout({
  title,
  description,
  lastUpdated,
  children,
}: {
  title: string;
  description?: string;
  lastUpdated: string;
  children: ReactNode;
}) {
  const pageDescription =
    description ?? `${title} for WagerWatchdog. Last updated: ${lastUpdated}.`;

  return (
    <Box minH="100vh" bg="gray.900">
      <PageMeta title={title} description={pageDescription} />
      <Navbar />
      <Box pt={{ base: 12, md: 16 }} pb={{ base: 16, md: 24 }}>
        <Container maxW="container.md">
          <VStack spacing={8} align="stretch">
            <VStack spacing={2} align="start">
              <Heading
                as="h1"
                fontSize={{ base: '3xl', md: '4xl' }}
                fontWeight="bold"
                color="white"
              >
                {title}
              </Heading>
              <Text fontSize="sm" color="gray.500">
                Last updated: {lastUpdated}
              </Text>
            </VStack>
            <Box
              color="gray.300"
              lineHeight="1.8"
              fontSize={{ base: 'sm', md: 'md' }}
              sx={{
                'h2': {
                  color: 'white',
                  fontSize: { base: 'xl', md: '2xl' },
                  fontWeight: 'bold',
                  mt: 10,
                  mb: 4,
                },
                'h3': {
                  color: 'white',
                  fontSize: { base: 'lg', md: 'xl' },
                  fontWeight: 'semibold',
                  mt: 6,
                  mb: 3,
                },
                'p': {
                  mb: 4,
                },
                'ul, ol': {
                  pl: 6,
                  mb: 4,
                },
                'li': {
                  mb: 2,
                },
                'a': {
                  color: 'primary.400',
                  textDecoration: 'underline',
                  _hover: { color: 'primary.300' },
                },
              }}
            >
              {children}
            </Box>
          </VStack>
        </Container>
      </Box>
      <Footer />
    </Box>
  );
}

export {
  Heading,
  Text,
  VStack,
  Link,
  UnorderedList,
  OrderedList,
  ListItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Divider,
  RouterLink,
  Box,
};
